import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

import { ClassName } from '@sim/role';

import { BaseICCDFormArrayComponent } from '@atmi/shared/iccd/base-iccd-form-array.component';

@Component({
  selector: 'app-mtc-form',
  styleUrls: ['./mtc-form.component.scss'],
  templateUrl: './mtc-form.component.html',
})
export class MtcFormComponent extends BaseICCDFormArrayComponent<string[]> implements OnDestroy, OnInit {

  @Input() classNames: ClassName[] = [];

  get mtcs() {
    const form = this.form && this.form.controls;
    return form || [];
  }

  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  addMTCHandler() {
    if (!this.form || !this.form.controls) {
      throw new Error('Cannot manage MTC without a control');
    }

    const MTCControl = new UntypedFormControl('');
    this.form.push(MTCControl);
  }

  removeMTCHandler(index: number) {
    if (!this.form || !this.form.controls) {
      throw new Error('Cannot manage MTC without a control');
    }

    this.form.removeAt(index);
  }
}
